// extracted by mini-css-extract-plugin
export default {"login_header":"LoginHeader_login_header__P33SP","amway_logo":"LoginHeader_amway_logo__9CW2I"};